import  {useEffect, useState, useRef} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {ModifiedToast} from './toaster';
import { Helmet, HelmetProvider } from "react-helmet-async";
import { FormInput } from "./formInput";
import PrimaryButton from "./primaryButton";
import { useLoginUserMutation } from "../services/authApi";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {emailValidator, passwordValidator} from "../pages/settings/validation";
import { openJoyce } from '../redux/JoyiceSlice/joyiceSlice';


const PartnerLogin = () => {
  const navigate = useNavigate();
  const [ loginUser, { data, isLoading, isError, isSuccess, error:apiError } ] = useLoginUserMutation();
  
  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      navigate('/dashboard');
    }
  }, []);
  const dispatch = useDispatch(); 
  const [ passwordShown, setPasswordShown ] = useState(false);
   const [ formData, setFormData ] = useState({
    email:'',
    password:''
   });
  const [ error, setError ] = useState({
    emailError: '',
    passwordError: ''
  });
 
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  
  const toastId = useRef(null);
  useEffect(() => {
    if (isLoading) {
      toastId.current = toast.loading("Please wait...", {
      position: "top-right",
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      autoClose: 2000,
      theme: "colored",
      type: "info"
    });
    }
    if (isSuccess) {
      toast.dismiss( toastId.current);

       setTimeout(() => {
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem("loggedInUser", JSON.stringify(data.data));
        dispatch(openJoyce({isJoyce:false, isSignup:false, data:data}));
        navigate('/dashboard');
       
        toast.success(" User has been logged in successfully.", {
          render: " User has been logged in successfully.",
               type: "success",
               autoClose: 2000,
             isLoading: false
        });
      }, 210);
    }
    if (isError) {
      toast.dismiss( toastId.current);
      const toastMessage = apiError?.data?.message
        ? apiError?.data?.message
        : "Something went wrong";
        toast.error(toastMessage, {
          render: toastMessage,
               type: "error",
               autoClose: 3000,
             isLoading: false,
             theme: "colored",
             closeOnClick: true,
             pauseOnHover: true
        });
      
    }
  }, [ isSuccess, isError, isLoading ]);


  const handlerChange = (e) => {
    const {name} = e.target;
      if(name === 'email') {
        let email = emailValidator(e.target.value);
        setError({...error, emailError : email});
      } else if(name === 'password') {
        let password = passwordValidator(e.target.value);
        setError({...error, passwordError: password});
      }
    
   setFormData({...formData, [name] :e.target.value});
      
  };

  const validaForm = () => {
    const {email, password } = formData;
    let isFormValidated = true;

    if(email === '') {
    
    setError((errorValue) => { 
      return {
        ...errorValue,
        emailError: 'Please enter Email'
      };
    });
      isFormValidated = false;
  } 
   if(password === '') {
    setError((errorValue) => { 
      return {
        ...errorValue,
        passwordError: 'Please enter password'
      };
    });
      isFormValidated= false;

  }
  if(password.length < 8) {
    setError((errorValue) => { 
      return {
        ...errorValue,
        passwordError: 'Password must be at least 8 characters long'
      };
    });
      isFormValidated= false;

  }
  return isFormValidated;
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if(validaForm()) {
      loginUser(formData);
    }
  };
  
  return (
    <div className="h-screen flex bg-gray-bg1 w-full">
      <HelmetProvider>
        <Helmet>
          <title>Simplyenglish AI | Login </title>
        </Helmet>
      </HelmetProvider>

      <div className=" flex align-center h-screen w-full">
        <div className=" w-full bg-white  ">
          <div className="md:flex align-center justify-between h-full items-center flex-wrap md:flex-nowrap 	">
            <div className=" md:p-8 p-2 md:w-1/2 w-full relative">
              <div className=" pt-0">
                <div className="w-full max-w-lg m-auto bg-white lg:p-8 p-4 pt-0 border shadow-lg rounded-lg ">
                  <div className="text-center w-full MobileLoginImage">
                    <img
                      src="./images/logo.png"
                      width="270"
                      className="mx-auto"
                    />
                  </div>
                  <h1 className="text-xl font-semibold my-6 mb-8 text-center">
                    Log in to your account
                  </h1>
                  <form
                    onSubmit={handleFormSubmit}
                    className="text-left"
                    id="loginForm"
                  >
                    <div className="parentGroup mb-2">
                      <label htmlFor="email" className="formBlock">
                        {" "}
                        Email
                      </label>
                      <FormInput
                        inputType="text"
                        inputName="email"
                        inputID="email"
                        value = {formData.email}
                        handlerChange={handlerChange}
                       
                      />
                      <div className="help-block text-red-700">{error.emailError ? error.emailError:''}</div>
                    </div>
                    <div className="parentGroup mb-2 eyeIcon">
                      <label htmlFor="password" className="formBlock">
                        Password
                      </label>
                      <FormInput
                        inputType={passwordShown ? "text" : "password"}
                        inputName="password"
                        inputID="password"
                        value ={formData.password}
                         handlerChange={handlerChange}
                      />

                      <i className={
                          passwordShown
                            ? "fa fa-eye cursor-pointer"
                            : "fa fa-eye-slash cursor-pointer"
                        } onClick={togglePasswordVisiblity}
                      />
                     
                    </div>
                    <div className="help-block text-red-700">{error.passwordError ? error.passwordError:''}</div>
                    <p className="primary-text text-right mb-4">
                      <Link to="/forgot-password" className="font-medium">
                        Forgot password?
                      </Link>
                    </p>
                    <div className="form-group mb-4 ">
                      <label className="formBlock flex	">
                        <input type="checkbox" className="mr-2 w-5 h-5" />
                        Remember me
                      </label>
                    </div>

                    <div className=" mt-8 text-center">
                     
                         <PrimaryButton
                          btnText="Login "
                          Btnclass="btn save w-full  mb-6"
                          onClick={(e) => handleFormSubmit(e)} 
                          />
                        
                      <p className="text-gray-600 font-medium">
                        Not a Member yet?{" "}
                        <Link
                          to="/signup"
                          className="primary-text font-semibold"
                        >
                          Signup
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className=" md:w-1/2 md:h-full flex flex-wrap  md:flex hidden bg-white justify-center relative items-center  ">
            <div className="loginImage bg-white w-full">
                <div className="text-center w-full  px-12 mb-6 mt-2 ">
                  <img
                    src="./images/logo.png"
                    width="270"
                    className="mx-auto mb-4"
                  />
                </div>
                <img src="./images/login.jpg" className="userImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModifiedToast />
    </div>
  );
};

export default PartnerLogin;
